import { PROFILE } from "../../data/content";
import { Reveal } from "./Reveal";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 md:py-32 bg-primary text-primary-foreground"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <p className="font-mono-accent text-xs uppercase tracking-[0.22em] text-primary-foreground/60 mb-8">
            Get in touch
          </p>
        </Reveal>

        <Reveal delay={0.05}>
          <h2 className="font-serif-display font-medium tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02] max-w-3xl">
            Let&apos;s make your workplace compliant.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-primary-foreground/70">
            Call or message me directly for POSH training, IC advisory, complaint
            redressal or policy work. No forms, no gatekeeping.
          </p>
        </Reveal>

        {/* Direct phone — hero of the section */}
        <Reveal delay={0.15}>
          <a
            href={`tel:${PROFILE.phoneHref}`}
            data-testid="contact-phone"
            className="group mt-12 flex flex-wrap items-baseline gap-x-5 gap-y-2"
          >
            <span className="font-mono-accent text-[11px] uppercase tracking-[0.22em] text-primary-foreground/50">
              Call / WhatsApp
            </span>
            <span className="font-serif-display text-2xl md:text-3xl leading-none tracking-tight border-b border-primary-foreground/30 group-hover:border-accent transition-colors duration-300 pb-1">
              {PROFILE.phone}
            </span>
          </a>
        </Reveal>

        {/* Secondary details */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 border-t border-primary-foreground/20 pt-10">
          <Reveal delay={0.1}>
            <div>
              <p className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-primary-foreground/50 mb-3">
                Email
              </p>
              <a
                href={`mailto:${PROFILE.email}`}
                data-testid="contact-email"
                className="font-serif-display text-xl md:text-2xl border-b border-primary-foreground/30 hover:border-accent transition-colors duration-300 pb-0.5 break-all"
              >
                {PROFILE.email}
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div>
              <p className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-primary-foreground/50 mb-3">
                Chambers
              </p>
              <p className="font-serif-display text-xl md:text-2xl">
                {PROFILE.firm}
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div>
              <p className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-primary-foreground/50 mb-3">
                Counsel
              </p>
              <p className="font-serif-display text-xl md:text-2xl">
                {PROFILE.name}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
